import productGridAdapter from '@core-ui/product-grid/src/adapters';
import { ProductGroup } from '@core-ui/product-grid/types';
import { MappedBloomreachResponse } from '../../../../../types/mapped-bloomreach-response';

const productGridDataAdapter = (mappedBloomreachResponse: MappedBloomreachResponse): ProductGroup[] => {
  const emptyProductGroups = [{
    cid: '',
    heading: '',
    products: []
  }];

  return Object.keys(mappedBloomreachResponse || {}).length > 0
    ? productGridAdapter(mappedBloomreachResponse)
    : emptyProductGroups;
};

export default productGridDataAdapter;
